import { motion } from "framer-motion";
import { Mail, Phone, PhoneCall } from "lucide-react";
import { CONTACT } from "../data";

export const Contact = () => {
  return (
    <section
      id="kontakt"
      data-testid="contact-section"
      className="bg-[#DC2626] py-16 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 grid lg:grid-cols-2 gap-10 items-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="font-anton uppercase text-white/80 tracking-widest text-sm">
            Kontakt
          </span>
          <h2 className="font-anton uppercase text-white text-4xl md:text-6xl mt-3 leading-[0.95]">
            Porozmawiajmy o Twoim zleceniu
          </h2>
          <p className="mt-5 text-white/90 text-base md:text-lg max-w-md">
            Napisz do nas, a wspólnie ustalimy zakres prac sprzętem Bobcat.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="bg-white border-2 border-[#09090B] shadow-[10px_10px_0_0_rgba(9,9,11,1)] p-8"
        >
          <p className="font-anton uppercase text-2xl text-[#09090B]">
            ONE WAY TRANSPORT
          </p>

          <a
            data-testid="contact-email"
            href={CONTACT.emailLink}
            className="mt-6 flex items-center gap-4 group"
          >
            <span className="w-12 h-12 bg-[#DC2626] flex items-center justify-center shrink-0">
              <Mail className="text-white" size={22} />
            </span>
            <span>
              <span className="block text-xs uppercase tracking-widest text-zinc-500">
                Email
              </span>
              <span className="font-semibold text-[#09090B] group-hover:text-[#DC2626] transition-colors break-all">
                {CONTACT.email}
              </span>
            </span>
          </a>

          <a
            data-testid="contact-phone"
            href={CONTACT.phoneLink}
            className="mt-5 flex items-center gap-4 group"
          >
            <span className="w-12 h-12 bg-[#09090B] flex items-center justify-center shrink-0">
              <Phone className="text-white" size={22} />
            </span>
            <span>
              <span className="block text-xs uppercase tracking-widest text-zinc-500">
                Telefon
              </span>
              <span className="font-semibold text-[#09090B] group-hover:text-[#DC2626] transition-colors">
                {CONTACT.phone}
              </span>
            </span>
          </a>

          <div className="mt-8 grid sm:grid-cols-2 gap-3">
            <a
              data-testid="contact-call-button"
              href={CONTACT.phoneLink}
              className="bg-[#DC2626] text-white font-anton uppercase tracking-wider px-6 py-4 flex items-center justify-center gap-2 hover:bg-[#09090B] transition-colors"
            >
              <PhoneCall size={20} />
              Zadzwoń teraz
            </a>
            <a
              data-testid="contact-email-button"
              href={CONTACT.emailLink}
              className="bg-white text-[#09090B] border-2 border-[#09090B] font-anton uppercase tracking-wider px-6 py-4 flex items-center justify-center gap-2 hover:bg-[#09090B] hover:text-white transition-colors"
            >
              <Mail size={20} />
              Napisz e-mail
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
